import { INDIVIDUAL } from './_http';

const getLifeDetail = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/LifeInsurance/GetLifeGeneralInfo`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getLifeDetailTwo = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/LifeInsurance/GetPolicyDetail`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getLifePayments = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/LifeInsurance/GetPaymentInfoOfPolicy`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

export { getLifeDetail, getLifeDetailTwo, getLifePayments }